import React from "react";
import { Button } from "react-bootstrap";

const FilterShell = ({ children, onApply, onClear }) => {
  return (
    <div className="filters-wrapper card p-3 mb-3">
      <form method="post" onSubmit={(e) => e.preventDefault()}>
        <div className="row g-2">{children}</div>

        <div className="d-flex gap-2 mt-3">
          <Button onClick={onApply}>
            <span>Apply</span>
          </Button>
          <Button onClick={onClear}>
            <span>Clear</span>
          </Button>
        </div>
      </form>
    </div>
  );
};

export default FilterShell;
